<script lang="ts">
	import type { Organization } from '../api';
	import Card from './Card.svelte';
	import CardActions from './CardActions.svelte';
	import Icon from './Icon.svelte';
	import RoleBadge from './RoleBadge.svelte';

	interface Props {
		organization: Organization;
		isOwner: boolean;
		onEdit?: (organization: Organization) => void;
		onDelete?: (organization: Organization) => void;
		onViewDetails?: (organization: Organization) => void;
	}

	const { organization, isOwner, onEdit, onDelete, onViewDetails }: Props = $props();

	function handleEdit() {
		if (onEdit) {
			onEdit(organization);
		}
	}

	function handleDelete() {
		if (onDelete) {
			onDelete(organization);
		}
	}

	function handleViewDetails() {
		if (onViewDetails) {
			onViewDetails(organization);
		}
	}
</script>

<Card>
	<div class="flex items-start justify-between">
		<div class="min-w-0 flex-1">
			<h3 class="truncate text-lg font-medium text-gray-900">
				{organization.name}
			</h3>
			<p class="mt-1 text-sm text-gray-500">
				{organization.countryName || organization.country?.isoName || 'Unknown Country'}
			</p>
			{#if organization.memberCount !== undefined}
				<p class="mt-2 flex items-center gap-1 text-sm text-gray-600">
					<Icon name="users" size={16} />
					{organization.memberCount} member{organization.memberCount === 1 ? '' : 's'}
				</p>
			{/if}
		</div>

		<div class="ml-4">
			<CardActions
				onView={onViewDetails ? handleViewDetails : undefined}
				onEdit={isOwner && onEdit ? handleEdit : undefined}
				onDelete={isOwner && onDelete ? handleDelete : undefined}
				viewTitle="View organization details"
				editTitle="Edit organization"
				deleteTitle="Delete organization"
			/>
		</div>
	</div>

	<div class="mt-4">
		<RoleBadge {isOwner} />
	</div>
</Card>
